import { IAutoMapper } from "../interfaces";

export const mapMemberM360Response = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MemberM360Response")
    .forMember("memberRecords", o => automapper.mapMany("default", "MemberItem", o.memberRecords))
    .forMember("paginationToken", o => o.paginationToken);
};
